module.exports = __webpack_public_path__ + "static/img/IQ.444e8c72.png";